<!-- lista de conversas: cabeçalho, pesquisa + chips, linhas em simplebar -->
<div class="chat-list">
  <div class="chat-list__head">
    <div class="chat-list__bar">
      <h2 class="chat-list__title">{{ strings.listTitle }}</h2>
      <button *ngIf="view === 'mine' && mineSegment === 'staff'" type="button" class="chat-list__plus" [attr.aria-label]="strings.newConversation"
        [ngbTooltip]="strings.newConversation" container="body" (click)="newConversation.emit()">
        <chat-icon name="plus" [size]="18"></chat-icon>
      </button>
      <div class="chat-list__menu">
        <button type="button" class="chat-list__me" [attr.aria-label]="strings.myStatus" aria-haspopup="menu"
          [attr.aria-expanded]="menuOpen" [ngbTooltip]="myPresence === 'away' ? strings.presenceAwayShort : strings.presenceAvailable"
          container="body" (click)="toggleMenu()">
          <chat-avatar [src]="mePhoto" [name]="meName" [size]="32" [status]="myPresence"></chat-avatar>
        </button>
        <div *ngIf="menuOpen" class="chat-list__popover" role="menu">
          <div class="chat-list__me-head">
            <span class="chat-list__me-name">{{ meName }}</span>
            <span class="chat-list__me-sub">{{ strings.myStatus }}</span>
          </div>
          <ng-container *ngIf="canSetAway">
            <button type="button" role="menuitemradio" class="chat-list__item" [attr.aria-checked]="myPresence === 'online'"
              [class.chat-list__item--on]="myPresence === 'online'" (click)="choosePresence('online')">
              <span class="chat-list__dot"></span>
              <span class="chat-list__item-text">{{ strings.presenceAvailable }}<small>{{ strings.presenceAvailableHint }}</small></span>
              <chat-icon *ngIf="myPresence === 'online'" name="check" [size]="14"></chat-icon>
            </button>
            <button type="button" role="menuitemradio" class="chat-list__item" [attr.aria-checked]="myPresence === 'away'"
              [class.chat-list__item--on]="myPresence === 'away'" (click)="choosePresence('away')">
              <span class="chat-list__dot chat-list__dot--away"></span>
              <span class="chat-list__item-text">{{ strings.presenceAwayShort }}<small>{{ strings.presenceAwayHint }}</small></span>
              <chat-icon *ngIf="myPresence === 'away'" name="check" [size]="14"></chat-icon>
            </button>
          </ng-container>
          <hr *ngIf="canSetAway && (settingsLink || pageLink)" class="chat-list__sep">
          <a *ngIf="pageLink" role="menuitem" class="chat-list__item" [routerLink]="pageLink" (click)="menuOpen = false">
            <chat-icon name="next" [size]="15"></chat-icon>
            <span class="chat-list__item-text">{{ strings.launcherOpenPage }}</span>
          </a>
          <a *ngIf="settingsLink" role="menuitem" class="chat-list__item" [routerLink]="settingsLink" (click)="menuOpen = false">
            <chat-icon name="settings" [size]="15"></chat-icon>
            <span class="chat-list__item-text">{{ strings.settings }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- quem supervisiona: as minhas conversas | as da equipa (2026-10-26) -->
  <div *ngIf="canSupervise" class="chat-list__views" role="tablist" [attr.aria-label]="strings.listTitle">
    <button type="button" role="tab" class="chat-list__view" [class.chat-list__view--on]="view === 'mine'"
      [attr.aria-selected]="view === 'mine'" (click)="setView('mine')">
      {{ strings.viewMine }}<span *ngIf="clientsUnread + staffUnread > 0" class="chat-list__count chat-list__count--unread">{{ clientsUnread + staffUnread }}</span>
    </button>
    <button type="button" role="tab" class="chat-list__view" [class.chat-list__view--on]="view === 'supervision'"
      [attr.aria-selected]="view === 'supervision'" (click)="setView('supervision')">
      {{ strings.viewSupervision }}<span *ngIf="supervisionAttention > 0" class="chat-list__count chat-list__count--queue"
        [ngbTooltip]="strings.tabQueue" container="body">{{ supervisionAttention }}</span>
    </button>
  </div>

  <div class="chat-list__filters">
    <label class="chat-list__search" [class.chat-list__search--filled]="hasQuery">
      <span class="chat-sr-only">{{ strings.searchLabel }}</span>
      <chat-icon name="search" [size]="15"></chat-icon>
      <input #searchInput type="search" class="chat-list__input" autocomplete="off" [placeholder]="strings.searchPlaceholder"
        (input)="onSearch($event)">
      <button *ngIf="hasQuery" type="button" class="chat-list__clear" [attr.aria-label]="strings.clearSearch" (click)="clearSearch()">
        <chat-icon name="close" [size]="12"></chat-icon>
      </button>
    </label>

    <!-- As minhas: filtros do separador de baixo (2026-10-27) -->
    <div *ngIf="view === 'mine'" class="chat-list__chips" role="group" [attr.aria-label]="strings.filtersLabel">
      <button type="button" class="chat-list__chip" [class.chat-list__chip--on]="mineFilter === 'all'"
        [attr.aria-pressed]="mineFilter === 'all'" (click)="setMineFilter('all')">
        {{ strings.tabAll }}<span *ngIf="segmentCount > 0" class="chat-list__count">{{ segmentCount }}</span>
      </button>
      <button type="button" class="chat-list__chip" [class.chat-list__chip--on]="mineFilter === 'unread'"
        [attr.aria-pressed]="mineFilter === 'unread'" (click)="setMineFilter('unread')">
        {{ strings.tabUnread }}<span *ngIf="segmentUnread > 0" class="chat-list__count chat-list__count--unread">{{ segmentUnread }}</span>
      </button>
    </div>

    <!-- Supervisão > Clientes: todas, ou só onde um cliente espera resposta -->
    <div *ngIf="view === 'supervision' && supervisionSegment === 'clients'" class="chat-list__chips" role="group" [attr.aria-label]="strings.filtersLabel">
      <button type="button" class="chat-list__chip" [class.chat-list__chip--on]="supervisionFilter === 'all'"
        [attr.aria-pressed]="supervisionFilter === 'all'" (click)="setSupervisionFilter('all')">{{ strings.tabAll }}</button>
      <button type="button" class="chat-list__chip" [class.chat-list__chip--on]="supervisionFilter === 'waiting'"
        [attr.aria-pressed]="supervisionFilter === 'waiting'" (click)="setSupervisionFilter('waiting')">{{ strings.filterWaiting }}</button>
    </div>
  </div>

  <div class="chat-list__body">
    <!-- skeleton: só enquanto a primeira lista não chegou -->
    <div *ngIf="showSkeleton" class="chat-list__skeleton" role="status" [attr.aria-label]="strings.loading">
      <div *ngFor="let w of skeletonRows" class="chat-list__sk-row" aria-hidden="true">
        <span class="chat-sk chat-sk--avatar"></span>
        <span class="chat-list__sk-lines">
          <span class="chat-sk chat-sk--line" [style.width.%]="w"></span>
          <span class="chat-sk chat-sk--line chat-sk--thin"></span>
        </span>
      </div>
    </div>

    <!-- As minhas -->
    <ngx-simplebar *ngIf="view === 'mine' && visible.length > 0" class="chat-list__scroll">
      <div class="chat-list__rows">
        <chat-conversation-item *ngFor="let c of visible; trackBy: trackByKey" [conversation]="c"
          [presence]="presenceOf(c)" [active]="keyOf(c) === activeKey" [strings]="strings"
          (select)="select.emit($event)"></chat-conversation-item>
      </div>
    </ngx-simplebar>

    <!-- Supervisão: consultores fechados, 10 de cada vez (2026-10-27) -->
    <ngx-simplebar *ngIf="view === 'supervision'" class="chat-list__scroll">
      <chat-supervision [kind]="supervisionSegment" [filter]="supervisionFilter" [search]="searchTerm" [queue]="queue"
        [canAssign]="canAssign" [activeKey]="activeKey" [presence]="presence" [online]="online" [profileBase]="profileBase"
        [normalizeRow]="normalizeRow" [strings]="strings" (select)="select.emit($event)"></chat-supervision>
    </ngx-simplebar>

    <div *ngIf="isEmpty" class="chat-list__empty">
      <!-- com pesquisa, o vazio é sempre "nenhuma conversa encontrada" -->
      <chat-empty-state *ngIf="hasQuery" icon="search" [title]="strings.emptySearchTitle" text=""></chat-empty-state>
      <ng-container *ngIf="!hasQuery">
        <ng-container *ngIf="mineFilter === 'unread'">
          <chat-empty-state icon="check2" [title]="strings.emptyUnreadTitle" [text]="strings.emptyUnreadText"></chat-empty-state>
        </ng-container>
        <ng-container *ngIf="mineFilter === 'all'">
          <chat-empty-state *ngIf="mineSegment === 'clients'" icon="chat" [title]="strings.emptyListTitle" [text]="strings.emptyListText"></chat-empty-state>
          <chat-empty-state *ngIf="mineSegment === 'staff'" icon="users" [title]="strings.emptyStaffTitle" [text]="strings.emptyStaffText"
            [actionLabel]="strings.newColleagueConversation" (action)="newConversation.emit()"></chat-empty-state>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- rodapé: o que a lista mostra (2026-10-27: voltou) -->
  <div *ngIf="view === 'mine'" class="chat-list__foot" role="tablist">
    <button type="button" role="tab" class="chat-list__seg" [class.chat-list__seg--on]="mineSegment === 'clients'"
      [attr.aria-selected]="mineSegment === 'clients'" (click)="setMineSegment('clients')">
      <chat-icon name="users" [size]="16"></chat-icon>{{ strings.segmentClients }}
      <span *ngIf="clientsUnread > 0" class="chat-list__count chat-list__count--unread">{{ clientsUnread }}</span>
    </button>
    <button type="button" role="tab" class="chat-list__seg" [class.chat-list__seg--on]="mineSegment === 'staff'"
      [attr.aria-selected]="mineSegment === 'staff'" (click)="setMineSegment('staff')">
      <chat-icon name="chat" [size]="16"></chat-icon>{{ strings.segmentStaff }}
      <span *ngIf="staffUnread > 0" class="chat-list__count chat-list__count--unread">{{ staffUnread }}</span>
    </button>
  </div>
  <div *ngIf="view === 'supervision'" class="chat-list__foot" role="tablist">
    <button type="button" role="tab" class="chat-list__seg" [class.chat-list__seg--on]="supervisionSegment === 'clients'"
      [attr.aria-selected]="supervisionSegment === 'clients'" [ngbTooltip]="strings.supervisionClientsHint" container="body"
      placement="top" (click)="setSupervisionSegment('clients')">
      <chat-icon name="users" [size]="16"></chat-icon>{{ strings.segmentClients }}
    </button>
    <button type="button" role="tab" class="chat-list__seg" [class.chat-list__seg--on]="supervisionSegment === 'staff'"
      [attr.aria-selected]="supervisionSegment === 'staff'" [ngbTooltip]="strings.supervisionStaffHint" container="body"
      placement="top" (click)="setSupervisionSegment('staff')">
      <chat-icon name="chat" [size]="16"></chat-icon>{{ strings.segmentStaffSupervision }}
    </button>
  </div>
</div>
